<agr-page-toolbar
  [pageTitle]="'app.performance' | translate"
  [isEmpty]="(cycles$ | async)?.length === 0"
  [emptyTitle]="'performance.cycles-empty-title' | translate"
  [emptyDescription]="'performance.cycles-empty-description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  data-test="cycle-overview"
  primaryActionIcon="assignment"
  [primaryActionText]="'performance.add-week' | translate"
  (primaryAction)="openAddWeekDialog()"
  [hasPrimaryAction]="true"
>
  <agr-filter [config]="filterConfig" [disableDefaultOnClear]="true" (clear)="resetFilter()">
  </agr-filter>
  <div
    *ngIf="(observations$ | async)?.length > 0 && selectedSections$ | async as sections"
    class="flex--row flex--gutter padding-all"
  >
    <agr-summary-card-horizontal
      *ngFor="let section of sections"
      class="flock-overview-week-registration__item flex--column flex__child--auto"
      [attr.data-test]="'section-card_' + section.id"
      [title]="section.name + ' (' + section.barn.name + ')'"
      [actions]="getSummaryCardActions$(section) | async"
      [items]="
        getSummaryCardItems(
          section.id,
          weeklyKpiDataResults$ | async,
          selectedWeekNr$ | async,
          observations$ | async,
          selectedKpiParameters$ | async
        )
      "
    >
      abc
    </agr-summary-card-horizontal>
  </div>
  <ng-container
    [ngTemplateOutlet]="
      !((selectedCycle$ | async)?.arrivals.length > 0)
        ? first
        : !((observations$ | async)?.length > 0)
          ? second
          : third
    "
  ></ng-container>
  <ng-template #first>
    <agr-notification-empty
      [isEmpty]="(hasArrivals$ | async) === false"
      [emptyTitle]="'performance.arrivals-empty-title' | translate"
      [emptyDescription]="'performance.arrivals-empty-description' | translate"
    >
    </agr-notification-empty>
  </ng-template>
  <ng-template #second>
    <agr-notification-empty
      [isEmpty]="!((observations$ | async)?.length > 0)"
      [emptyTitle]="'performance.observations-empty-title' | translate"
      [emptyDescription]="'performance.observations-empty-description' | translate"
    >
    </agr-notification-empty>
  </ng-template>
  <ng-template #third></ng-template>
</agr-page-toolbar>
